<template>
  <div class="attraction-page" v-if="selectedAttraction">
    <div class="w3-row">
      <div class="w3-col s12 m6 l8">
        <ads type="attraction-page"></ads>

        <button @click="goBack" class="w3-button w3-right w3-red" style="margin-left:4px;">Back</button>
        <div class="sectionHeader">
          <h5>{{selectedAttraction.name}}</h5>
        </div>

        <template v-if="width < 601">
          <img v-if="selectedAttraction.imageUrl && selectedAttraction.imageUrl != ''" class="attractionImage" style="padding:0 4px; margin-bottom:8px;" :alt="selectedAttraction.name" :src="selectedAttraction.imageUrl" />
        </template>

        <div class="attractionContent whiteContainer" v-if="selectedAttraction.description" v-html="selectedAttraction.description"></div>
        <div class="attractionContent whiteContainer" v-if="!selectedAttraction.description"> No description available</div>

        <template v-if="width > 600">
          <template v-if="showReviews">
            <reviews :item="selectedAttraction"></reviews>
          </template>
        </template>
      </div>
      <div class="w3-col s12 m6 l4 attractionSidebar">
        <template v-if="width > 600">
          <img v-if="selectedAttraction.imageUrl && selectedAttraction.imageUrl != ''" :alt="selectedAttraction.name" class="attractionImage" style="padding:0 4px; margin-bottom:8px;" :src="selectedAttraction.imageUrl" />
        </template>
        <template v-if="selectedAttraction.url">
          <div class="sectionHeader w3-display-container">
            <h5>Share Page</h5>
          </div>
          <div class="whiteContainer" style="margin:0 4px 8px;">
            <div class="w3-row">
              <div class="w3-col s4 w3-center">
                <a class="w3-block w3-blue w3-padding" :href="share('fb', selectedAttraction.url)" aria-label="facebook share" target="_blank" rel="noreferrer">
                  <font-awesome-icon :icon="['fab', 'facebook-f']"></font-awesome-icon>
                </a>
              </div>
              <div class="w3-col s4 w3-center">
                <a class="w3-block w3-light-blue w3-padding" :href="share('tw', selectedAttraction.url)" aria-label="twitter share" target="_blank" rel="noreferrer">
                  <font-awesome-icon :icon="['fab', 'twitter']"></font-awesome-icon>
                </a>
              </div>
              <div class="w3-col s4 w3-center">
                <a class="w3-block w3-red w3-padding" :href="share('gp', selectedAttraction.url)" aria-label="google share" target="_blank" rel="noreferrer">
                  <font-awesome-icon :icon="['fab', 'google-plus']"></font-awesome-icon>
                </a>
              </div>
            </div>
          </div>
        </template>
        <template v-if="selectedAttraction.latlng">
          <div class="sectionHeader w3-display-container">
            <h5>Map</h5>
          </div>
          <div class="whiteContainer" style="margin:0 4px 8px;">
            <div id="map" ref="map" style="min-height:150px; width:100%;" aria-label="map"></div>
          </div>
        </template>
        <div class="sectionHeader w3-display-container">
            <!-- <button type="button" class="w3-button w3-display-left btnBack" @click="previousAttraction()">Previous</button> -->
            <h5>Attraction Details</h5>
            <!-- <button type="button" class="w3-button w3-display-right btnNext" @click="nextAttraction()">Next</button> -->
        </div>
        <div class="whiteContainer w3-padding" style="margin:0 4px 8px;">
          <ul style="list-style-type:none; margin:0; padding:0;">
            <template v-if="selectedAttraction.displayAddress">
              <a :href="'https://maps.google.com/?q=' + selectedAttraction.name + ' ' + selectedAttraction.displayAddress" target="_blank" class="attractionInfoLink">
                <li><font-awesome-icon icon="map" class="listItem"></font-awesome-icon>{{selectedAttraction.displayAddress}}</li>
              </a>
            </template>
            <template v-if="selectedAttraction.website">
              <template v-if="selectedAttraction.displayAddress"><hr></template>
              <a :href="selectedAttraction.website" target="_blank" rel="noreferrer" class="attractionInfoLink">
                <li><font-awesome-icon icon="globe" class="listItem"></font-awesome-icon>{{selectedAttraction.website}}</li>
              </a>
            </template>
            <template v-if="selectedAttraction.phone">
              <template v-if="selectedAttraction.displayAddress || selectedAttraction.website"><hr></template>
              <a :href="'tel:' + selectedAttraction.phone" target="_blank" rel="noreferrer" class="attractionInfoLink">
                <li><font-awesome-icon icon="phone" class="listItem"></font-awesome-icon>{{selectedAttraction.phone}}</li>
              </a>
            </template>
            <template v-if="selectedAttraction.hours && selectedAttraction.hours !== 'unknown'">
              <template v-if="selectedAttraction.displayAddress || selectedAttraction.website || selectedAttraction.phone"><hr></template>
              <li v-for="(day, index) of selectedAttraction.hours" :key="index"><font-awesome-icon icon="clock" class="listItem"></font-awesome-icon>{{day}}</li>
            </template>
            <!-- Google Rating -->
            <template v-if="selectedAttraction.rating">
              <template v-if="selectedAttraction.displayAddress || selectedAttraction.website || selectedAttraction.phone || (selectedAttraction.hours && selectedAttraction.hours !== 'unknown')"><hr></template>
              <div class="w3-row">
                <div class="w3-col s6">
                  Rating: {{selectedAttraction.rating}} / 5
                </div>
                <div class="w3-col s6">
                  <div class="rating-box w3-right">
                    <div class="rating" :style="{width: (selectedAttraction.rating / 5 * 100) + '%'}"></div>
                  </div>
                </div>
              </div>
            </template>
          </ul>
        </div>

        <template v-if="width < 601">
          <template v-if="showReviews">
            <reviews :item="selectedAttraction"></reviews>
          </template>
        </template>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import gmapsInit from '../gmaps'
import reviews from '@/components/reviews.vue'

export default {
  name: 'attraction-page',
  metaInfo () {
    let selectedAttraction = this.selectedAttraction
    if (selectedAttraction) {
      return {
        title: `${selectedAttraction.name} - Daytona Local`,
        meta: [
          {name: 'title', content: selectedAttraction.name},
          {name: 'description', content: selectedAttraction.name + ' Details and Information Page on DaytonaLocal.com'},
          {property: 'og:title', content: selectedAttraction.name + ' - Daytona Local'},
          {property: 'og:site_name', content: 'Daytona Local'},
          {property: 'og:type', content: 'website'},
          {property: 'og:url', content: 'https://daytonalocal.com/event-details/' + selectedAttraction.url},
          {property: 'og:image', content: selectedAttraction.image},
          {property: 'og:description', content: selectedAttraction.description},

          // Twitter card
          {name: 'twitter:card', content: selectedAttraction.description},
          {name: 'twitter:site', content: 'https://daytonalocal.com/event-details/' + selectedAttraction.url},
          {name: 'twitter:title', content: selectedAttraction.name + ' - Daytona Local'},
          {name: 'twitter:description', content: selectedAttraction.description},
          {name: 'twitter:image:src', content: selectedAttraction.image},

          // Google / Schema.org markup:
          {itemprop: 'name', content: selectedAttraction.name + ' - Daytona Local'},
          {itemprop: 'description', content: selectedAttraction.description},
          {itemprop: 'image', content: selectedAttraction.image}
        ]
      }
    }
  },
  components: {
    reviews
  },
  data() {
    return {
      showReviews: false,
      width: window.innerWidth
    }
  },
  computed: mapState([
    'allAttractions',
    'selectedAttraction'
  ]),
  methods: {
    openLink(link) {
      window.open(link, "_blank");
    },
    goBack() {
      this.$router.back()
    },
    async gmap() {
      if (this.selectedAttraction.latlng) {
        const google = await gmapsInit()
        let map = new google.maps.Map(this.$refs['map'], {
          center: {lat: this.selectedAttraction.latlng.lat, lng: this.selectedAttraction.latlng.lng},
          zoom: 14
        })
        let marker = new google.maps.Marker({
          position: this.selectedAttraction.latlng,
          map: map,
          title: this.selectedAttraction.name
        })

        if (this.selectedAttraction.place_id) {
          const reviewRequest = {
            placeId: this.selectedAttraction.place_id,
            fields: ['reviews']
          }
          const service = new google.maps.places.PlacesService(map)
          service.getDetails(reviewRequest, (place, status) => {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
              let attraction = this.selectedAttraction
              attraction.reviews = place.reviews
              this.$store.commit('setSelectedAttraction', attraction)
              this.showReviews = true
            }
          })
        }
      }
    },
    share(type, url) {
      let sharePage = ""
      if (type === 'fb') {
        sharePage = encodeURI("https://www.facebook.com/sharer.php?u=https://daytonalocal.com/attraction-details/" + url)
      } else if (type === 'tw') {
        sharePage = encodeURI("https://twitter.com/intent/tweet?url=https://daytonalocal.com/attraction-details/" + url)
      } else if (type === 'gp') {
        sharePage = encodeURI("https://plus.google.com/share?url=https://daytonalocal.com/attraction-details/" + url)
      } else {
        // nothing
      }
      return sharePage
    }
  },
  created() {
    if (this.$route.params.url) {
      this.$store.dispatch('getPlaces', 'attraction').then(() => {
        for (let attraction of this.allAttractions) {
          if (attraction.url === this.$route.params.url) {
            this.$store.commit('setSelectedAttraction', attraction)
            if (attraction.latlng) {
              this.gmap()
            }
          }
        }
      })
    }
  }
}
</script>

<style scoped>
  .attractionContent {padding:15px;}
  .attractionContent .w3-row {margin-bottom:8px; padding:8px 0; border-bottom: 1px solid #ddd}
  .attractionContent .w3-row:last-child {margin-bottom:0; padding-bottom:0; border-bottom: 0;}
  .attractionSidebar i {margin-right:8px;}
  
  .list-group {margin-bottom:15px; margin-top:15px;}
  .list-group-item {font-weight:300; cursor:pointer;}
  .list-group-item img {max-width:150px; float:left; margin:5px 10px 5px 0;}
  .listIcon {width:30px; color:#263238;}

  .attractionImage {width:100%; margin-bottom:15px;}

  .btnBack {background:#263238; color:#fafafa;}
  .btnBack:hover {background:#33434b;}
  .btnNext {background:#263238; color:#fafafa;}
  .btnNext:hover {background:#33434b;}

  a.attractionInfoLink {text-decoration:none; color:inherit;}
  a.attractionInfoLink:hover {text-decoration:underline; color:inherit;}

  .socialShare {height:32px; width:32px; margin-right:8px;}
  .socialShare:last-child {margin-right:0;}
</style>
